/**
 * Given a list of import functions, try imports until one succeeds
 */
function unwrapModule(mod) {
  return mod && mod.default !== undefined ? mod.default : mod;
}

export async function importFirst(imports) {
  for (let i = 0; i < imports.length; i++) {
    try {
      return {
        data: unwrapModule(await imports[i]()),
        index: i,
      };
    } catch (e) {
      // Ok, go on to next
    }
  }
  throw new Error("Couldn't import any files");
}

/**
 * Import All The Things
 * Resolve with an array with all the imported data, nulls for failures
 */
export async function importAll(imports) {
  return await Promise.all(
    imports.map(async item => {
      try {
        // This has to be provided as a function, since webpack
        // needs to see import statements with at least partial
        // paths in order to package the code properly
        return unwrapModule(await item());
      } catch (e) {
        return null;
      }
    })
  );
}
